import $ from "jquery";
/**
 * Common error tracking function
 * Logs the error locally and optionally sends it to an external service.
 * @param {string} context - Description of where the error occurred
 * @param {Error} error - The error object or message
 */
export function trackError(context, error) {
    //console.error(`[Error in ${context}]:`, error);
    $("#app_err").prepend(`
        <div class="alert alert-danger alert-dismissible fade show">
            <strong>Error!</strong><br/>`+context+`
            <p>`+error+`</p>
            <a href="javascript:void(0);" onclick="window.location.reload(true);">Click here to reload the page.</a>
        </div>
    `);

    // Optional: Integrate with an external error tracking service like Sentry
    // Sentry.captureException(new Error(`[${context}] ${error.message}`));
}